
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.287 0l.866 1.459.385.652L5.14 6.499l-2.6 4.388-.386.652L1.287 13l-.826-1.454v-.002l.867-1.461.385-.65 1.74-2.934-1.74-2.937-.387-.65-.866-1.46L1.287 0z","fill":"url(#paint0_linear_10697_30517)"}}),_c('path',{attrs:{"d":"M4.967 0l.866 1.459.384.652L8.82 6.499l-2.601 4.388-.386.652L4.967 13l-.826-1.454v-.002l.867-1.461.385-.65 1.74-2.934-1.741-2.937-.386-.65-.866-1.46L4.967 0z","fill":"url(#paint1_linear_10697_30517)"}}),_c('path',{attrs:{"d":"M8.647 0l.866 1.459.385.652L12.5 6.499l-2.6 4.388-.386.652L8.647 13l-.825-1.454v-.002l.866-1.461.385-.65 1.74-2.934-1.74-2.937-.387-.65-.866-1.46L8.647 0z","fill":"url(#paint2_linear_10697_30517)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_10697_30517","x1":"2.8","y1":"13","x2":"2.8","y2":"0","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#A23AD4"}}),_c('stop',{attrs:{"offset":".44","stop-color":"#813AD4"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#6037E0"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_10697_30517","x1":"6.48","y1":"13","x2":"6.48","y2":"0","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#4365AF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#558BDC"}})]),_c('linearGradient',{attrs:{"id":"paint2_linear_10697_30517","x1":"10.16","y1":"13","x2":"10.16","y2":"0","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#008F8C"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#51E0D4"}})])])])
          )
        }
      }
    